import { Tasks } from "../tasks"

export const TaskManager = ({pageSwap}) => {
    return(
        <Tasks
            pageSwap={pageSwap}
        />
    )
}